module.exports = __webpack_public_path__ + "static/media/battery.e527d594.png";